import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@d12labs/ui/card";
import type * as React from "react";

// Shared shell for /login, /signup, /forgot-password, /reset-password.
// Centers a small card on the canvas with a brand mark above and an
// optional footer link slot below. Pages stay focused on their own form.
export function AuthLayout({
	title,
	description,
	children,
	footer,
}: {
	title: string;
	description?: string;
	children: React.ReactNode;
	footer?: React.ReactNode;
}) {
	return (
		<div className="min-h-screen flex flex-col items-center justify-center p-4">
			<div className="w-full max-w-sm flex flex-col gap-6">
				<div className="text-center">
					<a href="/" className="text-lg font-semibold tracking-tight">
						d12-starter
					</a>
				</div>
				<Card>
					<CardHeader>
						<CardTitle>{title}</CardTitle>
						{description ? <CardDescription>{description}</CardDescription> : null}
					</CardHeader>
					<CardContent>{children}</CardContent>
				</Card>
				{footer ? <div className="text-center text-sm text-muted-foreground">{footer}</div> : null}
			</div>
		</div>
	);
}
